<lockvue-user-details-item *ngIf="showUserDetails; else aliasComponent" [value]="value.User">
</lockvue-user-details-item>

<ng-template #aliasComponent>
  <span>
    {{ value.UserAlias }}
    ({{ value.UserId }})
  </span>
</ng-template>
